import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {topoUtils} from '../utils/topo-utils';
import {geoUtils} from '../utils/geo-utils';
import {createSelector} from "reselect";

/**
 * Component for drawing city labels on the county map.
 *
 * The cities are filtered to match the stateFips value
 * and are defined in utils/cities.min.json
 *
 * @property height - height of the parent svg in pixels for placement
 * @property width - width of the parent svg in pixels for placement
 * @property stateFips - numeric state fips value to retrieve city values from topo-utils
 *
 * @example
 * return (
 *   <StateCityLabels
 *     width={500}
 *     height={500}
 *     stateFips={1}
 *   />
 * )
 */
export default class StateCityLabels extends PureComponent {

  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    stateFips: PropTypes.number
  }

  getFips = (props) => props.stateFips
  getWidth = (props) => props.width
  getHeight = (props) => props.height

  getTopography = createSelector(
    [this.getFips],
    (fips) => topoUtils.getStateTopography(fips)
  )

  getProjection = createSelector(
    [this.getFips, this.getWidth, this.getHeight],
    (fips, width, height) => geoUtils.getAlbersStateProjection(fips, width, height)
  )

  /**
   * Identify center point, and depending on which edge is closer align the label to the left or right.
   */
  renderLabel = (d, projection) => {
    const center = projection([d.long, d.lat])
    const nearEdge = center[0] > this.props.width * .8
    const textAnchor = nearEdge ? 'end' : 'start'
    const xOffset = nearEdge ? -8 : 8

    return (
      <g key={d.city}
         pointerEvents="none"
         transform={`translate(${center})`}>

        <circle
          cx={0}
          cy={0}
          r={4}
          fill={'#373737'}
          stroke={'#ffffff'}
          strokeWidth={1.5}
        />

        <text
          dy="0.32em"
          fill={'#ffffff'}
          stroke={'#ffffff'}
          strokeWidth={2.5}
          strokeLinecap="round"
          strokeLinejoin="round"
          fontFamily="arial,sans-serif"
          fontSize={10}
          fontWeight={600}
          textAnchor={textAnchor}
          x={xOffset}
          children={d.city}
        />

        <text
          dy="0.32em"
          fill={'#222'}
          stroke="none"
          fontFamily="arial,sans-serif"
          fontSize={10}
          fontWeight={600}
          textAnchor={textAnchor}
          x={xOffset}
          children={d.city}
        />

      </g>
    )
  }

  render() {
    const topo = this.getTopography(this.props);
    const projection = this.getProjection(this.props);

    return (
      <g className="StateCityLabels">
        {_.map(topo.cities, d => this.renderLabel(d, projection))}
      </g>
    )
  }
}
